export interface AppointmentWizardDate {
    date: string /** Fecha en formato yyyy-mm-dd */;
    availability: boolean /** Indica si se debe de deshabilitar en el calendario */;
}

/**
 * A factory function that creates AppointmentWizardDate
 */
export function createAppointmentWizardDate(
    params: Partial<AppointmentWizardDate>
) {
    return {} as AppointmentWizardDate;
}

/**
 * Factoría que crea una Appointment con los datos recogidos por la API
 */
export function appointmentWizardDateFactory(params: any) {
    return {
        date: params.DiaryDate,
        availability: params.Availability,
    } as AppointmentWizardDate;
}
